"use strict";

require("../../styles/components/carousel_flickity.scss");

require("../../styles/templates/product.scss");

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

var _productFaq = require("../components/productFaq");

var _productFaq2 = _interopRequireDefault(_productFaq);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Flickity is no longer imported: every carousel on this template is a
// <blossom-carousel>, which lays out and scrolls from CSS with no init step.
// carousel_flickity.scss above is kept — despite the name it holds the .carousel-cell
// styling the strips still rely on.

// PDP FAQ accordion (snippets/product-faq.liquid). Does nothing on a product with no FAQ band.
(0, _productFaq2.default)();

// --- PRODUCT GALLERY (Blossom Carousel) ---
// The gallery is <blossom-carousel class="product-carousel"> and the thumbnail rail
// is <blossom-dots class="product-thumbs">. Thumbs are drawn per slide by renderDot
// rather than rendered in Liquid, so rebuilding the slides for a variant is enough
// to rebuild the rail.
var productGallery = document.querySelector("blossom-carousel.product-carousel");
var productThumbs = document.querySelector("blossom-dots.product-thumbs");

// data-image-id and data-index are carried over from the old markup: district.js
// looks the thumb up by either one when a variant selection changes the image.
function renderProductThumb(index, active, forId) {
  var carousel = document.getElementById(forId);
  var slide = carousel ? carousel.querySelectorAll("[data-blossom-slide]")[index] : null;

  var button = document.createElement("button");
  button.type = "button";
  button.setAttribute("data-blossom-dot", "");
  button.className = active ? "thumb is-active" : "thumb";
  button.dataset.index = String(index);

  if (slide && slide.dataset.imageId) {
    button.dataset.imageId = slide.dataset.imageId;
  }

  var img = document.createElement("img");
  // Setting src to "" would resolve against the page URL and fire a wasted request.
  if (slide && slide.dataset.thumb) {
    img.src = slide.dataset.thumb;
  }
  img.alt = slide && slide.dataset.alt || "Product image " + (index + 1);
  img.width = 120;
  img.height = 120;
  img.loading = index === 0 ? "eager" : "lazy";
  img.decoding = "async";
  button.appendChild(img);

  return button;
}

if (productGallery && productThumbs && window.customElements) {
  // This bundle is deferred from <head> and blossom-min.js from the template body,
  // so blossom-dots has not upgraded yet — assigning renderDot now would create a
  // plain own property that shadows the component's accessor once it does.
  window.customElements.whenDefined("blossom-dots").then(function () {
    productThumbs.renderDot = renderProductThumb;
  });
}

// --- COLOUR / RELATED-PRODUCT AND LIFESTYLE CAROUSELS ---
// Every carousel on this template is a <blossom-carousel> now (product-colors-carousel,
// collection-carousel-product-section, product-description-happy-package and the
// lifestyle strip), so there is no Flickity init left here: Blossom lays out and
// scrolls from CSS alone. What remains is the progress bar, which used to be driven
// by Flickity's scroll event and now reads scrollLeft.
bindCarouselProgress(document);

document.addEventListener("shopify:section:load", function (event) {
  bindCarouselProgress(event.target);
});

function bindCarouselProgress(root) {
  root.querySelectorAll("blossom-carousel").forEach(function (carousel) {
    // Nearest ancestor that owns a progress bar, so a page with several carousels
    // drives each one's own bar rather than the first on the page.
    var bar = null;
    for (var node = carousel.parentElement; node && !bar; node = node.parentElement) {
      bar = node.querySelector(":scope > .progress-bar");
    }
    if (!bar) return;

    var queued = false;

    var paint = function paint() {
      queued = false;
      var scrollable = carousel.scrollWidth - carousel.clientWidth;
      var progress = scrollable > 0 ? Math.abs(carousel.scrollLeft) / scrollable : 0;
      bar.style.width = Math.max(0, Math.min(1, progress)) * 100 + "%";
    };

    carousel.addEventListener("scroll", function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(paint);
    }, { passive: true });
  });
}

var $atcButton = (0, _jquery2.default)("button#AddToCart");

// The touchstart/touchmove/touchend block that used to live here preventDefault()ed
// horizontal swipes so the page would not scroll underneath a Flickity drag. Blossom
// scrolls the element natively and sets overscroll-behavior-x: contain itself, so
// keeping it would have cancelled the very scroll the carousel depends on.

document.addEventListener("DOMContentLoaded", function () {
  var thumbs = document.querySelector(".product-thumbs");
  var images = document.querySelector(".product-images");
  var galleryWrapper = document.querySelector(".product-carousel"); // parent container

  if (!thumbs || !images || !galleryWrapper) return;

  var moveThumbs = function moveThumbs() {
    var isMobile = window.innerWidth < 1140;
    var productTop = thumbs.parentElement || document.querySelector(".product-top");

    if (isMobile && !images.contains(thumbs)) {
      // 👇 Move thumbs inside product images (for mobile/tablet), directly under the
      // gallery. Appending would drop them below anything else the column holds
      // (the Air Base fill-time table); for every other product the viewport is the
      // only child, so both land in the same place.
      var viewport = images.querySelector(".product-gallery-viewport");
      if (viewport) {
        viewport.after(thumbs);
      } else {
        images.appendChild(thumbs);
      }
    } else if (!isMobile && !images.contains(thumbs)) {
      // Already at the right place, no need to move
    } else if (!isMobile && images.contains(thumbs)) {
      // 👇 Move thumbs back outside for desktop layout
      var _productTop = images.parentElement;
      if (_productTop) {
        _productTop.insertBefore(thumbs, images);
      }
    }
  };

  // Run once on page load
  moveThumbs();

  // Listen for window resize and re-run (with debounce)
  var resizeTimeout = void 0;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(moveThumbs, 200);
  });
});

// upsell modal


var checkUpsellExists = function checkUpsellExists() {
  var productTags = window.theme.productTags;
  if (productTags.indexOf("upsells") >= 0) {
    document.getElementById("AddToCartUpsell").addEventListener("click", initAddCart);
  } else {
    // console.log('n/a');
  }
};

checkUpsellExists();
document.addEventListener('DOMContentLoaded', function () {
  var addToCartBtn = document.getElementById('AddToCartButton');
  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', function (event) {
      initAddCart(event);
    });
  }
});

// Add this helper function at the top of product.js
function waitForRebuy(callback) {
  var maxAttempts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 50;

  var attempts = 0;

  var checkRebuy = setInterval(function () {
    attempts++;

    if (window.Rebuy && window.Rebuy.Cart) {
      clearInterval(checkRebuy);
      callback();
    } else if (attempts >= maxAttempts) {
      clearInterval(checkRebuy);
      console.warn('Rebuy failed to load, falling back to standard cart');
      callback(true); // Pass fallback flag
    }
  }, 100); // Check every 100ms
}

// Update your initAddCart function


function initAddCart(event) {
  event.preventDefault();

  // Captured now, synchronously: currentTarget is only meaningful during dispatch,
  // and the fallback below reports back from an AJAX callback long after that.
  var $button = (0, _jquery2.default)(event.currentTarget || event.target);

  var form_id = "AddToCartForm";
  var $form = (0, _jquery2.default)('#' + form_id);
  var productTags = $form.data('product-tags') || '';

  console.log('=== initAddCart called ===');

  var form_id = "AddToCartForm";
  var $form = (0, _jquery2.default)('#' + form_id);

  var variantId = $form.find('[name="id"]').val();
  var quantity = $form.find('[name="quantity"]').val() || 1;
  var productTags = $form.data('product-tags') || '';

  // console.log('Variant ID:', variantId);
  // console.log('Quantity:', quantity);
  // console.log('Product Tags:', productTags);

  var properties = {};

  if (productTags.includes('is-preorder')) {
    console.log('✅ Tag found');
    properties = {
      'PREORDER': 'This item ships mid-December'
    };
  }

  // Wait for Rebuy to be available
  waitForRebuy(function (useFallback) {

    // Define fallback function
    var doStandardAjax = function doStandardAjax() {
      _jquery2.default.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: {
          id: variantId,
          quantity: parseInt(quantity),
          properties: properties
        },
        success: function success(data) {
          console.log('Added via standard cart:', data);
          initButtonSubmit();
          showAddedToCartFeedback($button);
        },
        error: function error(e) {
          console.error("Standard AJAX failed", e);
          addToCartFail(e);
        }
      });
    };

    if (useFallback || !window.Rebuy || !window.Rebuy.Cart) {
      // Fallback to standard Shopify AJAX
      doStandardAjax();
      return;
    }

    // Use Rebuy
    var cartChangeHandler = function cartChangeHandler(e) {
      console.log('✅ Cart changed successfully:', e.detail);
      initButtonSubmit();
      document.removeEventListener('rebuy:cart.change', cartChangeHandler);
    };

    document.addEventListener('rebuy:cart.change', cartChangeHandler);

    window.Rebuy.Cart.addItem({
      id: variantId,
      quantity: parseInt(quantity),
      properties: properties
    }).catch(function (err) {
      console.warn("Rebuy addItem failed, falling back to standard AJAX", err);
      document.removeEventListener('rebuy:cart.change', cartChangeHandler);
      doStandardAjax();
    });
  });
}

// function initAddCart() {
//   event.preventDefault();
//     var form_id = "AddToCartForm";
//       $.ajax({
//         type: 'POST', 
//         url: '/cart/add.js',
//         dataType: 'json', 
//         data: $('#'+form_id).serialize(),
//         success: function (data) {
//           initButtonSubmit();
//         },
//         error: addToCartFail
//       });
// }

function addToCartFail(obj, status) {
  alert('Cannot add to cart');
}

// Only reached when Rebuy never loaded, so its Smart Cart is not there to
// acknowledge the add and — on a product with no upsell modal — nothing else
// would either: the click would look like it did nothing. Swap the label and put
// it back, the same shape as district.js's own add-to-cart confirmation.
function showAddedToCartFeedback($button) {
  if (!$button || !$button.length) return;

  var $label = $button.find('span').first();
  var originalLabel = $label.length ? $label.html() : null;

  $button.addClass('is-added');
  if ($label.length) {
    $label.html('ADDED TO CART');
  }

  setTimeout(function () {
    $button.removeClass('is-added');
    if (originalLabel !== null) {
      $label.html(originalLabel);
    }
  }, 3000);

  // Rebuy normally keeps the header count in step. Without it, that count is the
  // only remaining signpost to the cart, so refresh it here.
  _jquery2.default.getJSON('/cart.js', function (cart) {
    (0, _jquery2.default)('.cart-count').text(cart.item_count);
  });
}

var initButtonSubmit = function initButtonSubmit() {
  // theme.liquid renders the upsell modal only when the product carries an
  // `upsell:<collection>` tag, and both ways out of it — the .close-main-modal X
  // and the .main-modal .overlay — live inside that markup. #AddToCartButton is on
  // every product, so locking the body unconditionally left untagged products with
  // `overflow: hidden` (which propagates to the viewport, and so also stops Lenis)
  // and nothing to click to release it: desktop still escaped via the Esc handler
  // in video-modal.js, mobile was frozen for good.
  if (!document.querySelector(".main-modal")) return;

  // Rebuy opens its Smart Cart on addItem. On mobile it covers the screen
  // completely, so leaving it up would hide our modal and its close button while
  // the body stayed locked behind both.
  if (window.Rebuy && window.Rebuy.SmartCart && window.Rebuy.SmartCart.hide) {
    window.Rebuy.SmartCart.hide();
  }

  (0, _jquery2.default)("body").addClass("show-main-modal noscroll");
};

// Safety net: if the Smart Cart opens anyway it owns the screen, its own scroll
// lock and its own close button, so hand the page over rather than leaving a
// `noscroll` of ours to outlive it.
document.addEventListener('rebuy:smartcart.show', function () {
  (0, _jquery2.default)("body").removeClass("show-main-modal noscroll");
});

// Delegated from body and bound once. These used to be re-bound inside
// initButtonSubmit, which runs on every add to cart, so the second add stacked a
// second handler and one upsell click fired the /cart/add.js POST twice.
(0, _jquery2.default)("body").on("click", "[data-add-upsell]", function (event) {
  event.preventDefault();
  var form_id = (0, _jquery2.default)(this).closest('form').attr('id');
  var itemClosest = (0, _jquery2.default)(this).closest('li');
  var itemBtnText = (0, _jquery2.default)(this).find('span');

  _jquery2.default.ajax({
    type: 'POST',
    url: '/cart/add.js',
    dataType: 'json',
    data: (0, _jquery2.default)('#' + form_id).serialize(),
    success: function success(data) {
      // console.log('added');
      itemClosest.addClass('is-added');
      itemBtnText.text('added');
      itemClosest.removeClass('show-sizes');
    },
    error: addToCartFail
  });
});

(0, _jquery2.default)("body").on("click", "[data-pick-size]", function (event) {
  event.preventDefault();
  (0, _jquery2.default)('li.show-sizes').removeClass('show-sizes');
  (0, _jquery2.default)(this).closest('li').addClass('show-sizes');
});

// Jersey Customization Options


var checkCustomizationExists = function checkCustomizationExists() {
  var productTags = window.theme.productTags;
  if (productTags.indexOf("add-customization") >= 0) {
    initCustomization();
  }
};

var initCustomization = function initCustomization() {
  var jerseyATC = document.getElementById('addcustom');

  jerseyATC.addEventListener('click', function (event) {
    event.preventDefault();

    var jerseyName = document.getElementById('jersey-name').value;
    var jerseyNum = document.getElementById('jersey-number').value;
    var jerseySize = document.getElementById('size-select').value;

    // Check if "No Name" or "No Number" checkboxes are selected
    var noNameChecked = document.getElementById('no-name-checkbox') && document.getElementById('no-name-checkbox').checked;
    var noNumberChecked = document.getElementById('no-number-checkbox') && document.getElementById('no-number-checkbox').checked;

    // Validation - allow empty fields if corresponding checkbox is selected
    var nameValid = jerseyName.length > 0 || noNameChecked;
    var numberValid = jerseyNum.length > 0 || noNumberChecked;
    var sizeValid = jerseySize !== 'nosize';

    if (nameValid && numberValid && sizeValid) {
      document.getElementById('personalize-modal-content').classList.remove('has-error');

      // Build properties object
      var properties = {
        'Jersey Name': jerseyName.toUpperCase(),
        'Jersey Number': jerseyNum
      };

      console.log('Adding custom jersey', properties);

      // Set up one-time event listener for cart change
      var cartChangeHandler = function cartChangeHandler(e) {

        // Same modal, same guard: initButtonSubmit hides the Smart Cart and only
        // locks the body when the upsell modal is actually on the page.
        initButtonSubmit();

        document.removeEventListener('rebuy:cart.change', cartChangeHandler);
      };

      document.addEventListener('rebuy:cart.change', cartChangeHandler);

      // Add item to Rebuy cart
      if (window.Rebuy && window.Rebuy.Cart) {
        window.Rebuy.Cart.addItem({
          id: jerseySize,
          quantity: 1,
          properties: properties
        });
      } else {
        console.error('❌ Rebuy Cart not available - falling back to form submit');
        document.removeEventListener('rebuy:cart.change', cartChangeHandler);
        (0, _jquery2.default)('#formid-customize').submit();
      }
    } else {
      document.getElementById('personalize-modal-content').classList.add('has-error');
    }
  });
};

checkCustomizationExists();

// ==========================================
// Magazine Upsell Component Functionality
// ==========================================
var initMagazineUpsell = function initMagazineUpsell() {
  var upsellWidget = document.getElementById('magazine-upsell-widget');
  if (!upsellWidget) return;

  var variantId = parseInt(upsellWidget.dataset.variantId, 10);
  var bbLoaderVariantId = parseInt(upsellWidget.dataset.bbLoaderVariantId, 10);

  console.log('Magazine Upsell initialized:', { variantId: variantId, bbLoaderVariantId: bbLoaderVariantId });

  // Handle 3-Pack checkbox click
  var threePackCheckbox = upsellWidget.querySelector('[data-action="add-three-pack"]');
  if (threePackCheckbox) {
    threePackCheckbox.addEventListener('change', function (e) {
      if (!this.checked) return;
      this.disabled = true;

      console.log('Adding 3-pack, variant ID:', variantId);

      // Check if Rebuy is available
      if (window.Rebuy && window.Rebuy.Cart) {
        // Set up one-time event listener for cart change
        var cartChangeHandler = function cartChangeHandler(evt) {
          console.log('✅ 3-Pack added successfully:', evt.detail);
          document.removeEventListener('rebuy:cart.change', cartChangeHandler);
        };
        document.addEventListener('rebuy:cart.change', cartChangeHandler);

        // Add item to cart
        window.Rebuy.Cart.addItem({ id: variantId, quantity: 3 });
      } else {
        console.warn('Rebuy not available');
        threePackCheckbox.checked = false;
        threePackCheckbox.disabled = false;
        alert('Cart system not ready. Please refresh and try again.');
      }
    });
  }

  // Handle Loader Bundle checkbox click (1x Magazine + 1x BB Speed Loader)
  var loaderBundleCheckbox = upsellWidget.querySelector('[data-action="add-loader-bundle"]');
  if (loaderBundleCheckbox) {
    loaderBundleCheckbox.addEventListener('change', function (e) {
      if (!this.checked) return;
      this.disabled = true;

      console.log('Adding loader bundle - Magazine:', variantId, '+ BB Loader:', bbLoaderVariantId);

      if (window.Rebuy && window.Rebuy.Cart) {
        // Track how many items we've added
        var itemsAdded = 0;

        // Set up event listener for cart changes
        var cartChangeHandler = function cartChangeHandler(evt) {
          itemsAdded++;
          console.log('✅ Item ' + itemsAdded + ' added:', evt.detail);

          if (itemsAdded === 1) {
            // First item added (magazine), now add the BB Speed Loader
            console.log('Adding BB Speed Loader...');
            window.Rebuy.Cart.addItem({ id: bbLoaderVariantId, quantity: 1 });
          } else if (itemsAdded >= 2) {
            // Both items added, cleanup
            console.log('✅ Loader bundle complete!');
            document.removeEventListener('rebuy:cart.change', cartChangeHandler);
          }
        };
        document.addEventListener('rebuy:cart.change', cartChangeHandler);

        // Start by adding the magazine
        window.Rebuy.Cart.addItem({ id: variantId, quantity: 1 });
      } else {
        console.warn('Rebuy not available');
        loaderBundleCheckbox.checked = false;
        loaderBundleCheckbox.disabled = false;
        alert('Cart system not ready. Please refresh and try again.');
      }
    });
  }
};

// Initialize magazine upsell when DOM is ready
document.addEventListener('DOMContentLoaded', initMagazineUpsell);

document.addEventListener('DOMContentLoaded', function () {
  gsap.registerPlugin(ScrollTrigger);
  var productHandle = window.theme.productHandle;
  var keywords = ['hk-razr', 'eject-x', 'shredder-luxe', 'hk-harmon', 'hk-army-gift-card', 'hk-eclipse-shredder', 'rmx-goggle-system', 'hostile-aeg', 'aeg-kit'];
  if (keywords.some(function (keyword) {
    return productHandle.toLowerCase().includes(keyword);
  })) {

    var targets = document.querySelectorAll(".product-description-container");
    ScrollTrigger.saveStyles(".content-section.last");

    ScrollTrigger.matchMedia({
      "(min-width: 994px)": function minWidth994px() {
        targets.forEach(function (target) {
          var pinImage = target.querySelector('.content-section.last');
          var tl = gsap.timeline({
            defaults: { duration: 1 },
            scrollTrigger: {
              trigger: target,
              start: "top 0%",
              end: "bottom -=10%",
              scrub: 1,
              pin: pinImage
            }
          });

          var pinHeader = target.querySelector('.inner-pin h4');
          var pinText = target.querySelector('.inner-pin p');
          var sectionImage = target.querySelector('.pin-image img');
          tl.from(pinHeader, { autoAlpha: 0, y: 0, duration: 0 });
          tl.from(pinText, { autoAlpha: 0, y: 0, duration: 0 }, 0);
        });
      }
    });
  }
});

var btntop = (0, _jquery2.default)('.back-to-top');

btntop.on('click', function (e) {
  e.preventDefault();
  (0, _jquery2.default)('html, body').animate({ scrollTop: 0 }, '300');
});

window.addEventListener("load", function () {
  var thumbs = document.querySelectorAll(".product-thumbs img");

  if (thumbs.length > 6) {
    var container = document.querySelector(".product-thumbs");

    if (container) {
      container.classList.add("has-many");
    }
  }
});

// Listen for variant image updates from district.js (or any other source)
document.addEventListener('variant:images:update', function (e) {
  var images = e.detail.images;
  if (!images || !images.length || !productGallery) return;

  var parent = productGallery.parentNode;
  var nextSibling = productGallery.nextSibling;

  // Detaching runs the component's disconnectedCallback, which tears the drag engine
  // down; re-attaching re-initialises it against the new slide set. The thumbnail
  // rail needs no help — it watches the carousel for child mutations and redraws.
  productGallery.remove();
  productGallery.textContent = "";

  images.forEach(function (src, index) {
    var cell = document.createElement("div");
    cell.className = "carousel-cell is-loaded";
    cell.setAttribute("data-blossom-slide", "");
    cell.dataset.thumb = src;
    cell.dataset.alt = "Product image " + (index + 1);

    var picture = document.createElement("picture");
    var img = document.createElement("img");
    img.src = src;
    img.alt = cell.dataset.alt;
    img.width = 600;
    img.height = 600;
    img.className = "carousel-img is-loaded";
    img.loading = index === 0 ? "eager" : "lazy";
    img.decoding = "async";

    picture.appendChild(img);
    cell.appendChild(picture);
    productGallery.appendChild(cell);
  });

  parent.insertBefore(productGallery, nextSibling);
  productGallery.scrollTo({ left: 0, behavior: "instant" });
});